import getPieveActivityEventText from '@/lib/activityEvents/getPieveActivityEventText.js';
import isPermissionApprovalInteractionResponseEvent from '@/lib/activityEvents/isPermissionApprovalInteractionResponseEvent.js';

const GENERIC_INTERACTION_RESPONSE_SUMMARY_SET = new Set(['interaction response submitted.']);

const shouldPreserveExistingInteractionResponseSummary = ({ existingEvent, incomingEvent }) => {
  if (!isPermissionApprovalInteractionResponseEvent(existingEvent)) {
    return false;
  }

  const normalizeSummaryKey = (value) => {
    return String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  };
  const existingSummary = getPieveActivityEventText(existingEvent).trim();
  const incomingSummary = getPieveActivityEventText(incomingEvent).trim();

  if (!existingSummary || !incomingSummary) {
    return false;
  }

  const existingIsGeneric = GENERIC_INTERACTION_RESPONSE_SUMMARY_SET.has(normalizeSummaryKey(existingSummary));
  const incomingIsGeneric = GENERIC_INTERACTION_RESPONSE_SUMMARY_SET.has(normalizeSummaryKey(incomingSummary));

  if (existingIsGeneric || !incomingIsGeneric) {
    return false;
  }

  return true;
};

export default shouldPreserveExistingInteractionResponseSummary;
